import { Box, Divider, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { getCounsellingTasks, UpdateTask } from "../../api/satactApi";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { TaskStatus, TaskStatusDispaly, UserTypeId } from "../../common/const";

const TaskType = {
    TODO: 'To Do',
    COMPLETED: 'Completed'
}

const ActionPlan = ({
    getCounsellorData,
}) => {
    const dispatch = useDispatch();
    const { user, loading } = useSelector((state) => state.auth);
    const [taskType, setTaskType] = useState(TaskType.TODO);
    const [tasks, setTasks] = useState([]);

    const getTaskData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getCounsellingTasks('COUNSELLING', user?.student_id, taskType === TaskType.TODO ? `${TaskStatus?.PENDING},${TaskStatus.IN_PROGRESS}`: TaskStatus.COMPLETED );
            setTasks(response.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (user?.student_id) {
            getTaskData();
        }
    }, [user, taskType]);

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <CommonCard
                borderRadius={2}
                headerContent={
                    <Fragment>
                        <Box
                            sx={{ padding: '13px' }}
                        >
                            <Typography fontWeight={600}>Action Plan & Assigned Tasks</Typography>
                            <Box mt={2} display="flex" gap={1}>
                                <CommonButton
                                    label={`${TaskType.TODO}`}
                                    width="8%"
                                    fontWeight={600}
                                    color={taskType === TaskType.TODO ? theme.palette.secondary.main : theme.palette.background.dark}
                                    background={taskType === TaskType.TODO ? theme.palette.primary.main : theme.palette.background.main}
                                    handleClick={() => setTaskType(TaskType.TODO)}
                                    marginBottom="0px"
                                    height="35px"
                                />
                                <CommonButton
                                    label={`${TaskType.COMPLETED}`}
                                    width="10%"
                                    fontWeight={600}
                                    color={taskType === TaskType.COMPLETED ? theme.palette.secondary.main : theme.palette.background.dark}
                                    background={taskType === TaskType.COMPLETED ? theme.palette.primary.main : theme.palette.background.main}
                                    handleClick={() => setTaskType(TaskType.COMPLETED)}
                                    marginBottom="0px"
                                    height="35px"
                                />
                            </Box>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Box>
                        {tasks.map((task, index) => (
                            <CommonCard
                                key={index}
                                background={theme.palette.background.main}
                                borderRadius={2}
                                paddingBottom="0px"
                                padding="13px"
                                marginTop={index === 0 ? "0px" : "10px"}
                                content={
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        sx={{
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <Box>
                                            <Box
                                                display="flex"
                                                gap={1}
                                                alignItems="center"
                                            >
                                                <img src="/Images/actionplan.png" alt="Action Plan" width="40px" height="auto" />
                                                <Box>
                                                    <Typography fontSize={16} fontWeight="600">{task?.title}</Typography>
                                                    <Typography fontSize={14} color="background.dark">Due Date: {moment(task?.due_date).format('MMM YY')}</Typography>
                                                    <Typography fontSize={14} color="background.dark">Assigned by: <span style={{ color: theme.palette.secondary.main, fontWeight: 600 }}>{`${task?.assigne?.first_name} ${task?.assigne?.last_name}`}</span></Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                        {user?.user_type_id === UserTypeId.Student && (task?.status === TaskStatus.PENDING || task?.status === TaskStatus.IN_PROGRESS) ? (
                                            <CommonButton
                                                label={task?.status === TaskStatus.PENDING ? "Start" : "Complete"}
                                                fontWeight={600}
                                                width={task?.status === TaskStatus.PENDING ? "50px" : "90px"}
                                                height="30px"
                                                marginBottom="0px"
                                                handleClick={async () => {
                                                    try {
                                                        dispatch(setLoading({
                                                            loading: true
                                                        }));
                                                        const response = await UpdateTask(task.task_id, {
                                                            "status": task?.status === TaskStatus?.PENDING ? TaskStatus.IN_PROGRESS : TaskStatus.COMPLETED,
                                                            "completed_at": new Date().toISOString()
                                                        });
                                                        if (response?.success) {
                                                            showNotification(response.message, 'success');
                                                            getTaskData();
                                                            getCounsellorData();
                                                        }
                                                    } catch (err) {
                                                        const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                                        showNotification(errorMessage, 'error');
                                                        dispatch(setLoading({
                                                            loading: false
                                                        }));
                                                    }
                                                }}
                                            />
                                        ) : (
                                            <Box
                                                sx={{
                                                    background: theme.palette.success.light,
                                                    padding: '3px 10px',
                                                    borderRadius: 1,
                                                }}
                                            >
                                                <Typography fontSize={13} color={'#01875F'} textAlign="center">{TaskStatusDispaly[task?.status]}</Typography>
                                            </Box>
                                        )}
                                    </Box>
                                }
                            />
                        ))}
                    </Box>
                }
                paddingBottom="0px"
                padding="13px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default ActionPlan;